// 인증 관련 localStorage 헬퍼.
// 토큰/유저 정보 저장 위치를 한 곳에서 관리하기 위해 모든 접근을 이 파일을 통해서만 수행.
// 나중에 저장 방식(쿠키 등)으로 바꿀 일이 생기면 여기만 수정하면 됨.

const TOKEN_KEY = 'cs_access_token';
const USER_KEY = 'cs_user';

export function saveAuth(accessToken, user) {
  localStorage.setItem(TOKEN_KEY, accessToken);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getCurrentUser() {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAuthenticated() {
  const token = localStorage.getItem(TOKEN_KEY);

  if (token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const payload = decodeURIComponent(
      atob(base64)
      .split("")
      .map((c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
    );
    // console.log(`payload: ${payload}`);
    const { exp } = JSON.parse(payload);
    const expired = Date.now() >= exp * 1000;

    return !expired;
  }

  return false;
}

export function isAdmin() {
  const role_admin = ['Admin', 'Manager', 'SiteManager'];
  const user = getCurrentUser();

  return role_admin.includes(user?.role);
}
